import $ from "jquery";
import bdjs from "@bd-core/bdjs";
import 'slick-carousel'


export const SchedulingPage = () => {
    const isScheduling = $("#scheduling-page").length > 0;

    if (!isScheduling) return;

    bdjs.hideLoading();

    let isLoading = false;
    const goToSessionPage = (e) => {
        if(isLoading) return false;

        const $theBtn = $(e.currentTarget);
        const method = $theBtn.attr("data-method");

        isLoading = true;
        $theBtn.addClass("is-loading");

        const sessionPageUrl = `/sessions/?method=${method}`;
        isLoading = false;
        window.location.href = sessionPageUrl;
        
    };

 
    

    $(".js-session-btn").on("click", goToSessionPage);
   
  
  
};